<div class="dashboard-container">

    <div class="filters-section">
        <!-- FFS Recommendation Filters -->
        <div class="filter-group">
            <h2 class="filter-title">{{ 'pages.dashboard.filter_by' | translate }}</h2>
            <div class="filter-checkboxes">
                <div *ngFor="let option of filterOptions; let i = index" class="filter-option">
                    <mat-checkbox
                            [checked]="option.checked"
                            (change)="option.checked = !option.checked; onFilterChange(i === 0, i)">
                        {{ option.translationKey | translate }}
                    </mat-checkbox>
                </div>
            </div>
        </div>
        
        <!-- Site and Unity Filters -->
        <div class="filter-group">
            <app-site-unity-filters 
                [initialFilters]="currentFilters"
                (filtersChange)="onSiteUnityFiltersChange($event)">
            </app-site-unity-filters>
        </div>
    </div>

    <ng-container>
        <div *ngIf="inspections.length === 0" class="no-results">
            <mat-icon class="warning-icon">warning</mat-icon>
            <h3>{{ 'pages.dashboard.no_inspections_recorded_title' | translate }}</h3>
            <p>{{ 'pages.dashboard.no_inspections_recorded_subtitle' | translate }}</p>
        </div>

        <div *ngIf="inspections.length > 0" class="inspections-grid">
            <div *ngFor="let inspection of inspections" class="inspection-item">
                <mat-card class="inspection-card">
                    <a [href]="'/equipment/'+ inspection.equipmentPoint.equipment.id"
                       target="_blank"
                       rel="noopener noreferrer"
                       class="card-link">
                        <mat-card-content class="pt-2">
                        <div class="d-flex flex-column h-100">
                            <div class="row-section align-items-center">
                                <div class="d-inline-flex align-items-center me-2">
                                    <mat-label class="inspection-label">
                                        #{{ inspection.equipmentPoint.equipment.name }}
                                        ● {{ inspection.equipmentPoint.label }}
                                    </mat-label>
                                    <div class="recommendation-badge"
                                         *ngIf="inspection.result.ffsRecommendationCode"
                                         [ngClass]="getRecommendationClass(inspection.result.ffsRecommendationCode)">
                                        {{ getRecommendationTranslationKey(inspection.result.ffsRecommendationCode) | translate }}
                                    </div>
                                </div>
                                <button mat-raised-button color="secondary" (click)="$event.stopPropagation();openInspectionDetails(inspection)">
                                    {{ 'pages.dashboard.view_details' | translate }}
                                </button>
                            </div>
                            <div class="row-section mt-3">
                                <div class="date-section">
                                    <mat-icon class="calendar-icon">calendar_today</mat-icon>
                                    <span class="date-text">{{ inspection.inspectionDate | localeDate:'mediumDate' }}</span>
                                    <ng-container>
                                        <app-custom-popover [index]="inspection.id" title="pages.inspectionItem.notes"
                                                            [content]="inspection.notes"
                                                            noContentMessage="pages.inspectionItem.no_notes"></app-custom-popover>

                                    </ng-container>
                                </div>

                                <div class="metric forced-cr" *ngIf="inspection.result.forcedCorrosionRate">
                                    <mat-label class="metric-label">{{ 'pages.inspectionItem.forced_cr' | translate }}
                                    </mat-label>
                                    <div class="metric-value">{{ inspection.result.forcedCorrosionRate | localeDecimal }}
                                        mm/yr.
                                    </div>
                                </div>

                                <div class="metric">
                                    <mat-label class="metric-label">{{ 'pages.inspectionItem.stat_cr' | translate }}
                                    </mat-label>
                                    <div class="metric-value">{{ inspection.result.statCorrosionRate | localeDecimal }}
                                        mm/yr.
                                    </div>
                                </div>

                                <div class="metric">
                                    <mat-label
                                            class="metric-label">{{ "pages.inspectionItem.expected_min_thick" | translate }}
                                    </mat-label>
                                    <div class="metric-value">{{ inspection.result.minThicknessExtrapolated | localeDecimal }}
                                        mm
                                    </div>
                                </div>
<!--
                                <button mat-icon-button class="edit-button">
                                    <mat-icon svgIcon="total-edit">edit</mat-icon>
                                </button>-->
                            </div>
                        </div>
                    </mat-card-content>
                    </a>
                </mat-card>
            </div>
        </div>

        <div class="pagination-container" *ngIf="inspections.length > 0">
            <pagination
                    [length]="totalItems"
                    [pageOffset]="itemsPerPage"
                    [pageIndex]="currentPage"
                    [titleKey]="'pages.users_management.inspections_per_page'"
                    [hidePageSize]="true"
                    (paginateChange)="onPageChange($event)">
            </pagination>
        </div>
    </ng-container>
</div>
